"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("../../elements/button/Button");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SEARCH_UK_POSTCODE_BUTTON = {
  component: _Button.UnderlinedButton,
  extra: true,
  name: 'search-uk-postcode-button',
  props: {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: "Search for UK postcode"
    }),
    className: 'c-button--underField'
  }
};
var _default = exports["default"] = SEARCH_UK_POSTCODE_BUTTON;